
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FutureSection } from './components/FutureSection';
import { ReasonSection } from './components/ReasonSection';
import { SelectedReasonSection } from './components/SelectedReasonSection';
import { FlowSection } from './components/FlowSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { StepsSection } from './components/StepsSection';
import { DirectorSection } from './components/DirectorSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { FixedCTABar } from './components/FixedCTABar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <ProblemsSection />
      <FutureSection />
      <ReasonSection />
      <SelectedReasonSection />
      <FlowSection />
      <ResultsSection />
      <TestimonialsSection />
      <FAQSection />
      <StepsSection />
      <DirectorSection />
      <ClosingSection />
      <Footer />
      <div className="h-16"></div>
      <FixedCTABar />
    </div>
  );
}
